import { RouterSelectors } from '@next/core-lib/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DeliveryModuleState, ActiveDelivery } from '../../models/delivery.model';

export const getDeliveryModuleState = createFeatureSelector<DeliveryModuleState>('deliveryModule');

export const getDeliveries = createSelector(getDeliveryModuleState, (state) =>
  state.deliveries
    .slice()
    .sort((a, b) => new Date(b.deliveryDate).getTime() - new Date(a.deliveryDate).getTime()),
);

export const getActiveDeliveries = createSelector(getDeliveries, (deliveries): ActiveDelivery[] =>
  deliveries
    .filter((d1) => d1.deliveryLines.find((l1) => l1.isActive))
    .map((d2) => ({
      deliveryId: d2.id,
      activeDeliveryLineExternalUniqueIdentifiers: d2.deliveryLines.reduce(
        (acc, l2) => (l2.isActive ? [...acc, l2.externalUniqueIdentifier] : acc),
        // TODO: Replace with l2.lineExternalUniqueIdentifier.
        [],
      ),
      deliveryOrigin: d2.deliveryOrigin,
    })),
);

export const getActiveDelivery = createSelector(
  getActiveDeliveries,
  (
    activeDeliveries,
  ): ((deliveryId: number) =>
    | ActiveDelivery
    | {
        deliveryId: number;
        activeDeliveryLineExternalUniqueIdentifiers: string[];
      }) =>
    (deliveryId: number) =>
      activeDeliveries.find((a) => a.deliveryId === deliveryId) || {
        deliveryId,
        activeDeliveryLineExternalUniqueIdentifiers: [],
      },
);

export const getSelectedDeliveryId = createSelector(
  getDeliveryModuleState,
  RouterSelectors.getRouteParam('deliveryId'),
  (state, deliveryId) => {
    const routeDeliveryId = parseInt(deliveryId, 10);
    if (!isNaN(routeDeliveryId) && routeDeliveryId > 0) {
      return routeDeliveryId;
    } else {
      return state.selectedDeliveryId;
    }
  },
);

export const getSelectedDelivery = createSelector(
  getSelectedDeliveryId,
  getDeliveries,
  (deliveryId, deliveries) => deliveries.find((d) => d !== null && d.id === deliveryId),
);
